import { useEffect, useState } from "react";
import { restaurant } from "../lib/data";

const links = [
  { label: "Story", href: "#story" },
  { label: "Menu", href: "#menu" },
  { label: "Gallery", href: "#gallery" },
  { label: "Visit", href: "#visit" },
  { label: "Manage", href: "/admin/menu" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#f9f6f0]/85 backdrop-blur-md border-b border-[#2c3528]/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center gap-3 group"
        >
          <span
            className={`h-9 w-9 rounded-full grid place-items-center border transition-all ${
              scrolled
                ? "bg-[#5b7053] border-[#5b7053] text-[#f9f6f0]"
                : "bg-[#f9f6f0]/15 border-[#f9f6f0]/40 text-[#f9f6f0] backdrop-blur"
            }`}
            aria-hidden
          >
            <span className="font-serif-display text-lg italic leading-none">
              Y
            </span>
          </span>
          <span
            className={`font-serif-display text-xl tracking-tight transition-colors ${
              scrolled ? "text-[#2c3528]" : "text-[#f9f6f0]"
            }`}
          >
            The Greek Yum Yum&rsquo;s
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`text-sm tracking-wide transition-colors ${
                scrolled
                  ? "text-[#2c3528] hover:text-[#5b7053]"
                  : "text-[#f9f6f0]/90 hover:text-white"
              }`}
            >
              {l.label}
            </a>
          ))}
          <a
            href={`tel:${restaurant.phoneRaw}`}
            data-testid="header-book-cta"
            className={`px-5 py-2.5 text-sm tracking-wide lift ${
              scrolled
                ? "bg-[#5b7053] text-[#f9f6f0] hover:bg-[#3f4f39]"
                : "bg-[#f9f6f0] text-[#2c3528] hover:bg-white"
            }`}
          >
            Book a Table
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className={`md:hidden h-10 w-10 grid place-items-center ${
            scrolled ? "text-[#2c3528]" : "text-[#f9f6f0]"
          }`}
          aria-label="Toggle menu"
        >
          <div className="space-y-1.5">
            <span
              className={`block h-px w-6 bg-current transition-transform ${
                open ? "translate-y-[6px] rotate-45" : ""
              }`}
            />
            <span
              className={`block h-px w-6 bg-current transition-opacity ${
                open ? "opacity-0" : ""
              }`}
            />
            <span
              className={`block h-px w-6 bg-current transition-transform ${
                open ? "-translate-y-[6px] -rotate-45" : ""
              }`}
            />
          </div>
        </button>
      </div>

      {/* Mobile */}
      <div
        className={`md:hidden overflow-hidden bg-[#f9f6f0] border-b border-[#2c3528]/10 transition-[max-height] duration-500 ease-out ${
          open ? "max-h-96" : "max-h-0"
        }`}
      >
        <div className="px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              className="font-serif-display text-2xl text-[#2c3528]"
            >
              {l.label}
            </a>
          ))}
          <a
            href={`tel:${restaurant.phoneRaw}`}
            data-testid="mobile-book-cta"
            className="mt-2 inline-flex w-fit px-5 py-3 bg-[#5b7053] text-[#f9f6f0] text-sm tracking-wider"
          >
            Book a Table
          </a>
        </div>
      </div>
    </header>
  );
};
